import css from 'styled-jsx/css';

export default css`
  .wrap-button {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sticky {
    position: fixed;
    background: var(--background-utils);
    z-index: 8;
    top: 55px;
    padding: 10px 32px;
    width: 100%;
    margin: 0px;
    box-shadow: var(--shadow-light-hover);
  }
  .sticky .switch-plan-position {
    bottom: 2px;
    right: 20%;
    font-size: 12px;
  }
  .sticky :global(.button-group) {
    margin-top: 0px !important;
    margin-bottom: 20px !important;
  }
  .sticky :global(.switch-plan-arrow) {
    right: 52px;
    top: 30px;
  }
  .promo-active {
    color: #010101;
    font-weight: 700;
    background: #ed9dfc;
  }
`;
